import { useDispatch, useSelector } from "react-redux";
import { ProgramsConductorAction } from "src/store";
import { PromotionCard } from "./promotion.card";
import { PromotionRowProps } from "./promotion.row.props";
import { createRef, useLayoutEffect, useRef } from "react";
import SimpleBar from "simplebar-react";
import { useWindowDimension } from "src/hooks";

export const PromotionRow: React.FC<PromotionRowProps> = ({
  config,
  items,
  ratio,
  index,
  date,
}) => {
  const dispatch = useDispatch();

  const scrollableNodeRef = createRef();
  const ref = useRef<HTMLDivElement>(null);

  const mobile = config?.find((x) => x.type === "mobile");
  const desktop = config?.find((x) => x.type === "desktop");
  const [width] = useWindowDimension();

  const closePromotion = (promotionIndex: number) => {
    dispatch(
      ProgramsConductorAction.hidePromotion(date, index, promotionIndex)
    );
  };

  // useLayoutEffect(() => {
  //   //@ts-ignore
  //   if (scrollableNodeRef.current) {
  //     setTimeout(() => {
  //       //@ts-ignore
  //       scrollableNodeRef.current &&
  //         //@ts-ignore
  //         scrollableNodeRef.current.scrollTo(
  //           //@ts-ignore
  //           scrollableNodeRef.current.scrollWidth,
  //           0
  //         );
  //     });
  //   }
  // }, [scrollableNodeRef]);
  const configState: any = useSelector(
    (state: any) =>
      state.ConfigState?.config?.appSetting?.promotion?.sliderSpeed
  );

  const reversed = typeof items !== "undefined" ? [...items].reverse() : [];

  return (
    <div
      className={
        width < 760 && desktop?.cellCount === 3
          ? "component-promotions-slider"
          : "component-promotions"
      }
      ref={ref}
    >
      <SimpleBar
        style={{ maxWidth: "100%" }}
        scrollableNodeProps={{ ref: scrollableNodeRef }}
      >
        <div className="d-flex py-2">
          {reversed.map((props, index) =>
            !props.hidden ? (
              <PromotionCard
                items={items.length}
                key={index}
                mobile={mobile?.cellCount || 3}
                desktop={desktop?.cellCount || 3}
                sliderSpeed={configState}
                {...props}
                ratio={ratio}
                onclose={() => closePromotion(items.length - index - 1)}
              />
            ) : null
          )}
        </div>
      </SimpleBar>
    </div>
  );
  // );
};
